// Respaldo bilingue del modal que publica un evento en redes sociales.
//
// POR QUE EXISTE: la pantalla estaba escrita solo en espanol —"Comparte este
// evento a traves de tu red social favorita", "Enlace del evento", "Copiar"— con
// un unico texto al reves, el aviso de copiado, que estaba solo en ingles
// ("Content copied to clipboard"). Quien tenia la interfaz en ingles leia el
// modal completo en espanol, y quien la tenia en espanol leia ese aviso en
// ingles.
//
// COMO SE RETIRA: el esquema remoto (/api/lang/sch) SIEMPRE gana. El encabezado
// ya tiene clave publicada (LB0147) y se lee con `texts?.LB0147 || ...`; el resto
// todavia no tiene clave, y el dia que backend las registre estos respaldos
// dejan de usarse solos.
//
// Los nombres de las redes (Facebook, Instagram, Telegram, WhatsApp) NO viven
// aqui: son nombres propios, se escriben igual en los dos idiomas y la prueba de
// respaldos bilingues —con razon— trata dos textos identicos como una traduccion
// que falta.

import { normalizeInterfaceLanguage } from "../interfaceLanguage";

const eventShareTexts = {
  es: {
    heading: "Enviar por mensaje",
    subheading: "Comparte este evento como publicación en tu red favorita",
    // Lo que se publica. Lleva el nombre del evento adentro: sin el, la
    // publicacion decia "Mira este evento" sin decir cual.
    postText: (eventName) =>
      eventName ? `Mira este evento: ${eventName}` : "Mira este evento en VivaNómada",
    shareOn: (network) => `Compartir en ${network}`,
    publishOn: (network) => `Publica en ${network}`,
    sendOn: (network) => `Comparte por ${network}`,
    instagramCopied:
      "Copiamos el texto y el enlace. Pégalos en tu publicación de Instagram.",
    instagramCopyFailed:
      "No se pudo copiar el texto. Usa el botón Copiar de abajo y pégalo en Instagram.",
    shareFailed: "No se pudo abrir la ventana para compartir.",
    linkLabel: "Enlace del evento",
    copyButton: "Copiar",
    copiedTooltip: "Enlace copiado",
    securityNote: "Tu información se comparte de forma segura y privada.",
    noLink: "Este evento todavía no tiene un enlace para compartir.",
  },
  en: {
    heading: "Send by message",
    subheading: "Share this event as a post on your favorite network",
    postText: (eventName) =>
      eventName ? `Check out this event: ${eventName}` : "Check out this event on VivaNomada",
    shareOn: (network) => `Share on ${network}`,
    publishOn: (network) => `Post on ${network}`,
    sendOn: (network) => `Share on ${network}`,
    instagramCopied:
      "We copied the text and the link. Paste them into your Instagram post.",
    instagramCopyFailed:
      "The text could not be copied. Use the Copy button below and paste it into Instagram.",
    shareFailed: "The sharing window could not be opened.",
    linkLabel: "Event link",
    copyButton: "Copy",
    copiedTooltip: "Link copied",
    securityNote: "Your information is shared safely and privately.",
    noLink: "This event does not have a link to share yet.",
  },
};

export const getEventShareTexts = (language) =>
  eventShareTexts[normalizeInterfaceLanguage(language)];
